import { registerListener } from "./useListeners";

const keydownKey = "keydown";
export const useKeydownListener = registerListener(window, keydownKey);
